// extracted by mini-css-extract-plugin
module.exports = {"fixed_header":"style_fixed_header__3evZD","view":"style_view__3-tMV","fold":"style_fold__1LaQ3","open":"style_open__25P7j","textAlign_center":"style_textAlign_center__6GTjD"};